import React from 'react';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

const Icon: React.FC<FontAwesomeIconProps> = ({ ...props }) => {
  return <FontAwesomeIcon {...props} />;
};

export type { IconProp, SizeProp };
export default Icon;
